module.exports = __webpack_public_path__ + "static/img/LD_GS-1350w.f627ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/LD_GS-1350w.png
// module id = qLq3
// module chunks = 38